import React, { useContext, useMemo } from "react"
import marked from "marked"

import Image from "../Image/Image"
import Text from "../Text/Text"
import Video from "../Video/Video"
import Title from "../Title/Title"
import File from "../File/File"

import LanguageContext from "../LanguageContext"

const LayerGreenTalkOrbit = ({ greenTalks, depth, handleModal }) => {
  const [language, setLanguage] = useContext(LanguageContext)
  const data = useMemo(() => greenTalks.sort((a, b) => 0.5 - Math.random()), [])
  let GTavailableSpotsDistance = 30
  const diametroCerchio = 40


  // old gt available spots
  // let tmpSpots = [
  //   [(diametroCerchio / 2) * Math.cos(0), 0, (diametroCerchio/2) * Math.sin(0)],
  //   [(diametroCerchio / 2) * Math.cos(45), 0, (diametroCerchio / 2) * Math.sin(45)],
  //   [(diametroCerchio / 2) * Math.cos(90), 0, (diametroCerchio / 2) * Math.sin(90)],
  //   [(diametroCerchio / 2) * Math.cos(135), 0, (diametroCerchio / 2) * Math.sin(135)],
  //   [(diametroCerchio / 2) * Math.cos(180), 0, (diametroCerchio / 2) * Math.sin(180)],
  //   [(diametroCerchio / 2) * Math.cos(225), 0, (diametroCerchio / 2) * Math.sin(225)],
  //   [(diametroCerchio / 2) * Math.cos(270), 0, (diametroCerchio / 2) * Math.sin(270)],
  //   [(diametroCerchio / 2) * Math.cos(315),0,(diametroCerchio/2) * Math.sin(315)]
    
  // ]
  
  const spawnGTavailableSpots = () => {
    let tmp_arr = []
    greenTalks.map((el, idx) => {
      tmp_arr.push([(diametroCerchio / 2) * Math.cos((Math.PI/(greenTalks.length/2)) * idx), 0, (diametroCerchio/2) * Math.sin((Math.PI/(greenTalks.length/2)) * idx)])
    })

    return tmp_arr
  }
  
  let GTavailableSpots = spawnGTavailableSpots()


  return (
    <>
     

      <mesh lookAt={[0, 0.5, 0]} position={[5, 10, -20]}>
        <meshBasicMaterial />
        <sphereBufferGeometry args={[10, 32, 32]} />
      </mesh>
      
      <group  position={[0, 0, 0]} rotation={[0, Math.PI/2 , 0]}>
      {data.map((el, idx) => {
        if (idx > GTavailableSpots.length - 1) {
          //spawnSpotsGT()
          //console.log(GTavailableSpots)
        }

        return (
          <Video
            key={idx}
            handleModal={handleModal}

            position={GTavailableSpots[idx]}
            image={el.Cover.localFile}
            title={el.Title}
            titleEng={el.Title}
            modalContentIT={marked(el.ContentITA)}
            modalContentEN={marked(el.ContentENG)}
            videoID={el.videoID}
            active={el.Active}
            speaker={el.speakers}
            type={"green-voice"}
          />
        )
      })}
      </group>
    </>
  )
}

export default LayerGreenTalkOrbit
